export const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.avi', '.ogv'];

export const isVideoUrl = (url: string): boolean => {
  if (url.includes('/video/upload/')) return true;
  try {
    const pathname = new URL(url).pathname.toLowerCase();
    return VIDEO_EXTENSIONS.some(ext => pathname.endsWith(ext));
  } catch {
    return VIDEO_EXTENSIONS.some(ext => url.toLowerCase().endsWith(ext));
  }
};

export const isVideoFile = (file: File): boolean =>
  VIDEO_EXTENSIONS.some(ext => file.name.toLowerCase().endsWith(ext));
